var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComputingAndSoftware = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Software-Notebook-Cog-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Software Notebook Cog 2 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.387 0.945 0.42 1.26c0.105 0.42 0.63 0.736 1.05 0.63l1.26 -0.315c1.156 -0.21 1.891 1.05 1.156 1.891l-0.945 0.945a0.824 0.824 0 0 0 0 1.156l0.945 0.945c0.736 0.84 0 2.206 -1.155 1.89l-1.26 -0.104c-0.42 -0.105 -0.946 0.105 -1.05 0.63l-0.421 1.26a1.135 1.135 0 0 1 -2.206 0l-0.42 -1.26c-0.105 -0.42 -0.63 -0.735 -1.05 -0.63l-1.26 0.315C0.294 9.768 -0.44 8.508 0.294 7.668l0.945 -0.946a0.824 0.824 0 0 0 0 -1.155L0.4 4.41c-0.735 -0.84 0 -2.206 1.155 -1.89l1.26 0.315c0.42 0.105 0.946 -0.105 1.051 -0.63l0.42 -1.261c0.21 -1.155 1.786 -1.155 2.1 0Zm0.473 5.094a1.576 1.576 0 1 1 -3.151 0 1.576 1.576 0 0 1 3.15 0Zm7.13 4.373a0.75 0.75 0 1 0 0 1.5h4.4a0.75 0.75 0 0 0 0 -1.5h-4.4Zm0 3.5a0.75 0.75 0 1 0 0 1.5h2.9a0.75 0.75 0 0 0 0 -1.5h-2.9Zm-4.75 0.75a0.75 0.75 0 0 1 0.75 -0.75h1.4a0.75 0.75 0 0 1 0 1.5h-1.4a0.75 0.75 0 0 1 -0.75 -0.75Zm5.45 4.1c-0.5 0.9 -1.5 1.5 -2.6 1.5s-2.1 -0.6 -2.6 -1.5H0.79v1.5c0 1.7 1.3 3 3 3h16.5c1.7 0 3 -1.3 3 -3v-1.5h-8.6Zm-13.3 -7.688v6.188h2V12.71a2.702 2.702 0 0 1 -0.643 -1.135l-0.244 -0.734 -0.689 0.172a2.87 2.87 0 0 1 -0.424 0.061Zm21.5 -2.812v9h-2v-9c0 -0.247 -0.252 -0.5 -0.5 -0.5l-8.363 0a2.65 2.65 0 0 0 -0.693 -1.365l-0.462 -0.463 0.171 -0.171h9.347c1.353 0 2.5 1.147 2.5 2.5Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComputingAndSoftware);
export default ForwardRef;